<template>
  <div class="page-product-table-box">
    <div class="page-header">
        <h2>{{$t('dsfx.t13')}}</h2>
    </div>

    <div class="searchwrap">
      <el-form :inline="true" class="table-form-inline search-left">
        <el-form-item :label="$t('dsfx.t20')">
          <el-select v-model="filterselector[0].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters0change">
            <el-option
              v-for="item in filterselector[0].options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('dsfx.t23')">
          <el-select v-model="filterselector[3].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters1change">
            <el-option
              v-for="item in filterselector[3].options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showrelatedselect" :label="$t('Seller.t10')">
          <el-select v-model="filterselector[4].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters4change">
            <el-option
              v-for="item in filterselector[4].options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showijdaifa" :label="$t('Seller.t21')">
          <el-select v-model="filterselector[5].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters5change">
            <el-option
              v-for="item in filterselector[5].options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-form :inline="true" :model="formInline" class="search-right" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="viewState.searchNeedle" :placeholder="$t('jgjk.s65')" size="mini" @keyup.enter.native="onTableListSaerch()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onTableListSaerch()" size="mini">{{ $t('dsfx.t26') }}</el-button>
          <el-button type="danger" plain @click="downloaddata()" :loading="downloading" size="mini">{{ $t('jgjk.s74') }}</el-button>
        </el-form-item>
      </el-form>

    </div>

    <div class="tablebox">
      <el-table 
        :cell-style="getTableCellStyle"
        @sort-change="sortTableList"
        v-loading="tableloading" 
        ref="multipleTable" 
        :data="tableData" 
        tooltip-effect="dark" 
        style="width: 100%" 
        size="mini"
        @cell-dblclick="editAuthorizeText"
        :default-sort = "{prop: 'Discount', order: 'ascending'}"
      >
        <el-table-column prop='ShopId' label="Shop ID" width="80"></el-table-column>
        <el-table-column :label="$t('dsfx.t571')" sortable='custom' prop="ShopName" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- 圆 30天以上
            三角 30天以内
            红为本品投诉记录、黄为被其他品牌投诉过 -->
            <i class="icon-shop-warning icon-shop-warning-c-r" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.ismore30day/1 === 1 && scope.row.isself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-t-r" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.is30day/1 === 1 && scope.row.isself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-c-y" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.ismore30day/1 === 1 && scope.row.isnotself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-t-y" @click="warningDetail(scope.row.ShopId)" 
              v-if="scope.row.is30day/1 === 1 && scope.row.isnotself/1 === 1"></i> 
            <!-- isYjdf 一件代发/批发 店铺名高亮色 -->
            <a :href="scope.row.ShopUrl" target="_blank" :class="{ispifa : scope.row.isYjdf/1 === 1 ? true :false }">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('dsfx.t20')" sortable='custom' prop="ChannelName" width="100">
          <template slot-scope="scope">
            <i class="channelicon" :class="scope.row.ChannelName"></i>
          </template>
        </el-table-column>
        <el-table-column prop='SellerName' :label="$t('report.s55')" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop='ShopLab' :label="$t('jgjk.s211')" sortable='custom' width="100"></el-table-column>
        <el-table-column sortable='custom' prop='SellerLocation' :label="$t('jgjk.s219')" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop='Authorize' :label="$t('dsfx.t23')" sortable='custom' width="80">
          <template slot-scope="scope">
            <el-switch
              v-if="userinfo.role/1 == 0 || userinfo.role/1 == 2"
              @change="saveAuthorizeText(scope.row.Authorize, scope.row)"
              v-model="scope.row.Authorize"
              active-color="#13ce66"
              inactive-color="#999999"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
            <span v-if="userinfo.role/1 == 1">{{ scope.row.AuthorizeText }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop='Discount' :label="$t('report.s51')" width="100"></el-table-column>
        <el-table-column v-if="showecommerce" prop="isQinqText" sortable='custom' :label="$t('DashboardProduct.barlegendnamefalse')" width="100"></el-table-column>
        <el-table-column sortable='custom' prop='TotalLink' :label="$t('Seller.t12')" width="80"></el-table-column>
        <el-table-column sortable='custom' prop='SkuTotalTrade' :label="$t('jgjk.s304')" width="120"></el-table-column>
        <el-table-column sortable='custom' prop='SkuTotalAmountStr' width="130">
          <template slot="header">
            {{ $t('jgjk.s303') }}
            <el-tooltip class="item" effect="dark" :content="saletype != 2 ? $t('jgjk.s301') : $t('jgjk.s302')" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>
        </el-table-column>
        <el-table-column sortable='custom' prop='daymonitortxt' label="活跃度" width="70">
          <template slot-scope="scope">
            <span :class="scope.row.daymonitortxt.classname">{{ scope.row.daymonitortxt.txt }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop='notes' :label="$t('Seller.t13')" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.iseditnotes == false">{{ scope.row.notes }}</span>
            <!-- onkeyup="value=value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\.\,\，\s]/g,'');" -->
            <el-input 
              v-inputfocus
              class="editnoteinput" 
              v-model="scope.row.notes" 
              v-if="scope.row.iseditnotes === true" 
              @blur="setnote(scope.row.label, scope.row.notes, scope.row.ShopId, scope.$index)"
              @keyup.enter.native="setnote(scope.row.label, scope.row.notes, scope.row.ShopId, scope.$index)"
              size="mini"
              maxlength="20">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('activebrand.t37')" sortable='custom' prop="label" width="100">
          <template slot-scope="scope">
            <i 
              class="el-icon-s-flag sellerlistbtn sellerlistbtn-flag" 
              :class="'flagcolor_' + scope.row.label/1" 
              @click="setflag(scope.row.label, scope.row.notes, scope.$index, scope.row.ShopId)">
            </i>
            <!-- <i class="el-icon-edit-outline sellerlistbtn" @click="shoptags(scope.row.ShopName, scope.row.label, scope.row.ShopId, scope.row.notes, scope.$index)"></i> -->
            <button class="btnshopdetail" type="button" @click="viewDetail(scope.row.ShopId)"></button>            
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes"
        :total="pagingtotal">
      </el-pagination>      
    </div>

    <!--显示最近10条记录-->
    <el-dialog
      :title="$t('Seller.t14')"
      :visible.sync="showwaring"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%">
      <div style="">
        <el-table :data="shopdetaillist" tooltip-effect="dark" size="mini">
          <el-table-column prop="CreateTime" :label="$t('dsfx.t28')" />
          <el-table-column prop="status" :label="$t('dsfx.t27')" />
        </el-table>
      </div>
    </el-dialog>

    <!-- 填写卖家备注 -->
    <el-dialog
      custom-class="sellertagdialog"
      :title="currentsellername"
      :visible.sync="showshopinfo"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="500px">
      <div style="font-size: 14px;" class="sellertaginput">
        <!-- 疑似出售假货，卖假货，盗图商品，非授权商品。。。。 -->
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea"
          resize="none">
        </el-input>        
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" size="mini" @click="setnote(currentlabe, textarea, currentshopid)">{{ $t('PageCommon.queding') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      downloading: false,
      textarea: '',
      currentshopid: '',
      currentlabe: '',
      ratevalue: 3.7,
      shopdetaillist: [],
      showwaring: false,
      showshopinfo: false,
      currentsellername: '',
      pagesize: 25,
      dialogTableData: [],
      showdialogtable: false,

      optionsRefresh: true,

      notvip1: JSON.parse(window.localStorage.getItem('status')).val < 1 ? false : true,
      notviptable: false,
      balance: '',

      feedbackcomplaindialog: false,
      userbalance: '',
      feedbackcomplainsuccess: false,

      feedbacksuccess: false,
      feedbackBtnDisable: true,//true:隐藏
      feedbackBtnId: 0,//反馈类型：判定错误/链接失效
      feedbackTextarea: '',//系统反馈内容
      feedbackSelectedIds: '',//反馈的数据ID
      feedbackOptionsval: null,
      feedbackOptions: [],
      feedbackdialogopen: false,//意见反馈对话框是否打开

      tableloading: true,
      viewState: {
          selectedTab: "tab_all",
          searchNeedle: '',
          model4Tab: {}
      },
      tableorder: 50, //81
      tablepid: 0,
      refresh: false,
      formInline: {
        user: '',
        region: ''
      },
      selectToolsChannel:'',
      selectToolsResult:'',
      selectToolsStatus:'',
      filterSelect:{
        channel : [], //渠道
        result: [],   //判定结果
        status : [],  //确信度
      },
      filterselector: [{
          fieldid: "ChannelName",
          source: "channels",
          options: [],
          default: ''
      },{
          fieldid: "Result",
          source: "result",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('DashboardProduct.barlegendnamefalse'),
            value: 0,
          },{
            name: this.$t('DashboardProduct.barlegendnametrue'),
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Bucket",
          source: "bucket",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: '低',
            value: 3,
          },{
            name: '中',
            value: 2,
          },{
            name: '高',
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Authorize",
          source: "authorize",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('dsfx.t52'),
            value: 1,
          },{
            name: this.$t('dsfx.t53'),
            value: 0,
          }],
          default: ''
      },{
          fieldid: "Related",
          source: "related",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('dsfx.t52'),
            value: 1,
          },{
            name: this.$t('dsfx.t53'),
            value: 0,
          }],
          default: ''
      },{
          fieldid: "pifa",
          source: "pifa",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('dsfx.t52'),
            value: 1,
          },{
            name: this.$t('dsfx.t53'),
            value: 0,
          }],
          default: ''
      }],      
      tableviewQuery: {
        key: "discrimination_report_paging",
        start_date: this.$store.state.startDate+' 00:00:00',
        end_date: this.$store.state.endDate+' 23:59:59',
        industry: "",
        category: "",
        brand: "",
        series: "",
        model: "",
        search: "",
        userid: "",
        page: "1",
        record_per_page: "10",
        rpstatus: "",
        channelids: "",
        discrimnants: "",
        confidence: "",
      },
      tableData: [],
      multipleSelection: [],
      currentPage1: 1,
      pagingtotal: 0,
      DiscriminantResultText: '',
      channelIdAndNameMap: {},
      subid: this.$route.params.Id,
      showecommerce: false,
      currentindex: 9999,
      showrelatedselect: false,
      showijdaifa: false,
      saletype: '',
      userinfo: JSON.parse(localStorage.getItem("userinfo")).val
    }
  },

  mounted(){
    let that = this
    that.selectHistory()
    that.checkLevel()
    that.getRelatedCount()
    that.requestTabAndDropdownData(that.$route.params.Id)
    that.tableviewModelChange(that.$route.params.Id)
  },

  methods: {

    /**
     * 记住筛选条件
     */
    selectHistory: function(){
      let that = this
      // console.log(JSON.parse(localStorage.getItem("sellerSelectHistory")))
      if(localStorage.getItem("sellerSelectHistory") != null && 
        localStorage.getItem("sellerSelectHistory") != '' &&
        localStorage.getItem("sellerSelectHistory") !=  undefined){
          let _s = JSON.parse(localStorage.getItem("sellerSelectHistory")).val
          that.filterselector[0].default = _s.channel
          that.filterselector[3].default = _s.authorize
      } else {
          that.filterselector[0].default = ''
          that.filterselector[3].default = ''
      }
    },

    /**
     * checklevel
     */
    checkLevel: function(){
      let sid = this.$route.params.Id
      let pkglist = JSON.parse(localStorage.getItem("price")).val
      let currentpkg = pkglist.find(o => o.subid/1 === sid/1)
      this.saletype = currentpkg.saletype
      /**
       * 2：专业版
       * 3：企业版
       */
      let ifshowecommerce = currentpkg.level
      this.showecommerce = ifshowecommerce/1 === 3 ? true : false
    },

    warningDetail: function(sid){
      this.showwaring = true
      this.getSubList(sid)
    },

    shoptags: function(shopname, label, shopid, notes, i){
      this.currentsellername = shopname
      this.textarea = notes
      this.currentshopid = shopid
      this.currentlabe = label
      // this.showshopinfo = true
      this.currentindex = i
      this.setnote()
    },

    setflag: function(label, notes, index, sid){
      let that = this
      that.tableData[index].label = label + 1 < 4 ? label + 1 : 1
      let url = that.API_URL + '/v3/price/shop/edit'
      let postdata= {
        project: that.$route.params.Id/1,
        shopId: sid/1, 
        notes: notes,
        label: that.tableData[index].label
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(postdata),
        success: function(data) {
          console.log(data)
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    setnote: function(label, notes, sid, i){
      let that = this
      let url = that.API_URL + '/v3/price/shop/edit'
      let postdata= {
        project: this.$route.params.Id/1,
        shopId: sid/1, 
        notes: notes,
        label: label
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(postdata),
        success: function(data) {
          console.log(data)
          that.tableData[i * 1].iseditnotes = false
          // that.showshopinfo = false
          // that.textarea = ''
          // that.currentshopid = ''
          // that.currentlabe = ''
          // // that.tableData[that.currentindex].notes = notes
          // let _i = that.currentindex/1
          // that.tableData[_i].notes = notes
          // console.log('notes', that.tableData[_i].notes)
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    getSubList: function(sid){
      let that = this
      let url = that.API_URL + '/v3/price/shop/getcomplaintInfo?project=' + that.$route.params.Id + '&shopId=' + sid
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getSubList', rex)
          let _rex = rex.results
          _rex.forEach(item => {
            item.CreateTime = that.$moment(item.CreateTime).utc().format('YYYY-MM-DD HH:mm')
            item.status = that.setSubStatus(item.status/1)
          })
          that.shopdetaillist = _rex
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    getRelatedCount: function(){
      let that = this
      let url = that.API_URL + '/v3/price/shop/getCount?subid=' + this.$route.params.Id;
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getRelatedCount',rex)
          that.showrelatedselect = rex.results.count > 0 ? true : false
          that.showijdaifa = rex.results.isyjdf > 0 ? true : false
        },
        error: function(response) {
          console.log('getRelatedCount', response)
        }
      });
    },

    setSubStatus: function(status){
      // 1.待处理 2.处理中 3.平台审核不通过 4.撤销投诉 5.处理成功
      let str = ''
      switch(status){
        case 1:
          str = '待处理'
          break
        case 2:
          str = '处理中'
          break
        case 3:
          str = '平台审核不通过'
          break
        case 4:
          str = '撤销投诉'
          break
        case 5:
          str = '处理成功'
          break
      }
      return str
    },

    /**
     * 查看卖家详情
     */
    viewDetail: function(sid){
      let subid = this.subid
      this.$router.push({name: this.$route.path.indexOf('SPU') != -1 ? 'SPUSellerDetail' : 'SellerDetail', params: {Id: subid, Sid: sid}}) 
    },

    onTableListSaerch: function(){
      let searchKey = this.viewState.searchNeedle;
      console.log('onTableListSaerch', searchKey)
      let that = this
      that.tableviewModelChange(that.$route.params.Id)
    },

    filters0change: function(val){
      this.filterselector[0].default = val === '全部' ? '' : val
      this.setLocalStorage('sellerSelectHistory', {
        channel: val,
        authorize: this.filterselector[3].default
      })
      this.reloadTableData()
    },
    filters1change: function(val){
      this.filterselector[3].default = val === '全部' ? '' : val
      this.setLocalStorage('sellerSelectHistory', {
        channel: this.filterselector[0].default,
        authorize: val
      })
      this.reloadTableData()
    },
    filters2change: function(val){
      let valtxt = ''
      if(val === 1)valtxt = '低风险'
      if(val === 2)valtxt = '中风险'
      if(val === 3)valtxt = '高风险'
      this.filters[2].default = val === '' ? '' : valtxt
      console.log(val)
      this.reloadTableData()
    },
    filters4change: function(val){
      this.filterselector[4].default = val === '全部' ? '' : val
      this.reloadTableData()
    },
    filters5change: function(val){
      this.filterselector[5].default = val === '全部' ? '' : val
      this.reloadTableData()
    },

    reloadTableData: function(){
      this.tableviewQuery.page = '1'
      this.currentPage1 = 1
      this.channelids = this.filterselector[0].default
      let that = this
      that.requestTabAndDropdownData(that.$route.params.Id)
      that.tableviewModelChange(that.$route.params.Id)
    },
    
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      let that = this
      that.currentPage1 = 1
      that.tableviewQuery.page = 1
      that.pagesize = val
      that.tableviewModelChange(that.$route.params.Id)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.tableviewQuery.page = val
      let that = this
      that.tableviewModelChange(that.$route.params.Id)
    },

    requestTabAndDropdownData(ids) {
      let that = this
      let url = that.API_URL + '/v3/price/shop/filter'
      let data = {
        start: '',
        end: '',
        subid: ids,
        channel: '',
        series: '',
        model: '',
        search: ''
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('requestTabAndDropdownData', rex)

          //chanel
          if(that.optionsRefresh){
            let selectdefaultval = {
              name : that.$t('tabletabs.all'),
              value : ''
            }
            that.filterselector[0].options = rex.results[0].map(function(val){
              return {
                name: that.setChannel(val.Channel).loc,
                value: val.Channel
              }
            })
            
            that.filterselector[0].options.unshift(selectdefaultval)
            
            that.optionsRefresh = false
          }

        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    tableviewModelChange: function (ids) {

      let that = this

      // active loader
      that.activeTableLoader();
      
      that.tableviewQuery.userid =  localStorage.getItem("userid") && JSON.parse(localStorage.getItem("userid")).val;

      let newQuery = {
        start: '',
        end: '',
        subid: ids,
        page: that.tableviewQuery.page,
        channel: that.filterselector[0].default,
        authorize: that.filterselector[3].default,
        model: that.filterselector[2].default,
        search: that.viewState.searchNeedle,
        order: that.tableorder,
        size: that.pagesize,
        relatedShop: that.filterselector[4].default,
        isYidf: that.filterselector[5].default
      };
      let url = that.$route.name == 'PriceMonitoringSeller' ? 
        that.API_URL + '/v3/price/shop/paging' : that.API_URL + '/v3/price/spushop/paging';
      $.ajax({
        url:  url,
        type: "GET",
        data: newQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('#####-----tableviewModelChange',rex)
          let data = rex.results[1]
          data.forEach(
            item => {
              item.ChannelName = that.setChannel(item.Channel).src
              item.pid = ids
              item.Authorize = item.IsAuthor/1
              item.AuthorizeText = item.IsAuthor/1 ===  0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
              item.isQinqText = item.isQinq/1 ===  0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
              item.FakeSku = item.FakeItem
              item.Discriminant = item.ReportLink
              item.RightsProtectionStartTime = item.RightsProtectionTime != "" ? that.$moment(item.RightsProtectionTime).utc().local().format('YYYY-MM-DD HH:mm:ss') : item.RightsProtectionTime
              item.ResultId = item.ShopId
              item.Discount = (item.Discount * 100).toFixed(2) + "%"
              item.ShopLab = item.ShopLab === null ? '' : item.ShopLab === '跨境' ? that.$t('Seller.t8') : that.$t('Seller.t9')
              // item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? that.$t('jgjk.s245') + that.formartAmount(item.SkuTotalAmount) : 
              //                           item.Channel == '京东' ? 'NA' : that.$t('jgjk.s246') + that.formartAmount(item.SkuTotalAmount)
              item.SkuTotalAmountStr = (item.SkuTotalAmount * 1) >=0 && item.SkuTotalAmount != null ? that.millonFormat((item.SkuTotalAmount * 1).toFixed(0)) : item.SkuTotalAmount
              item.label = item.label/1 === 0 || item.label == null ? 1 : item.label/1
              item.shoplevel = item.shoplevel == null || item.shoplevel == '' ? 5 : item.shoplevel/1
              item.isedittype = false
              item.iseditnotes = false
              item.notes = item.notes == null || item.notes == 'null' || item.notes == '' ? '' : item.notes
              item.SkuTotalTrade = item.SkuTotalTrade  >=0 && item.SkuTotalTrade != null ? (item.SkuTotalTrade*1).toFixed(0) : item.SkuTotalTrade
              item.daymonitortxt = that.sellerActivilyLevel(item.daymonitor)
            }
          )

          that.tableData = data
          
          that.pagingtotal = rex.results[0][0].Count

          that.shutTableLoader()

        },
        error: function(response) {
          console.log(response)
        }
      });
    },
    
    // loader for table 
    activeTableLoader: function() {
      this.tableloading = true
    },
    shutTableLoader: function() {
      this.tableloading = false
    },

    /**
     * 下载数据
     */
    downloaddata: function(){
      let that = this
      that.downloading = true
      let url = that.$route.path.indexOf('SPU') != -1 ? that.API_URL + '/v3/price/spushop/shopitem?'
                + 'subid=' + that.subid : that.API_URL + '/v3/price/shop/shopitem?'
                + 'subid=' + that.subid
      let nowtime = new Date()
      let objname = JSON.parse(localStorage.getItem("price")).val
      let filenametime = that.$moment(nowtime,'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYYMMDDHHmm')
      let newname = ''
      for(let k=0; k<objname.length; k++){
        if(objname[k].subid/1 === that.$route.params.Id/1)
        newname = objname[k].name
      }
      let filename = newname ? newname : 'Download'
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '_Seller_' + filenametime+'.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
            that.downloading = false
          }
        }
      }
      xhr.send()      
    },

    /**
     * 自定义排序
     */
    sortTableList: function(column){
      let that = this
      if(column.order == "ascending"){
        switch(column.prop) {
          case 'ShopName':
            that.tableorder = '00'
            break
          case 'ChannelName':
            that.tableorder = '10'
            break
          case 'ShopLab':
            that.tableorder = '20'
            break
          case 'SellerLocation':
            that.tableorder = '30'
            break
          case 'Authorize':
            that.tableorder = '40'
            break
          case 'Discount':
            that.tableorder = '50'
            break
          case 'isQinqText':
            that.tableorder = '60'
            break
          case 'TotalLink':
            that.tableorder = '70'
            break
          case 'SkuTotalAmountStr':
            that.tableorder = '80'
            break
          case 'SkuTotalTrade':
            that.tableorder = '90'
            break
          case 'label':
            that.tableorder = '100'
            break
          case 'notes':
            that.tableorder = '110'
            break
          case 'daymonitortxt':
            that.tableorder = '120'
            break
        }
      }
      if(column.order == "descending"){
        switch(column.prop) {
          case 'ShopName':
            that.tableorder = '01'
            break
          case 'ChannelName':
            that.tableorder = '11'
            break
          case 'ShopLab':
            that.tableorder = '21'
            break
          case 'SellerLocation':
            that.tableorder = '31'
            break
          case 'Authorize':
            that.tableorder = '41'
            break
          case 'Discount':
            that.tableorder = '51'
            break
          case 'isQinqText':
            that.tableorder = '61'
            break
          case 'TotalLink':
            that.tableorder = '71'
            break
          case 'SkuTotalAmountStr':
            that.tableorder = '81'
            break
          case 'SkuTotalTrade':
            that.tableorder = '91'
            break
          case 'label':
            that.tableorder = '101'
            break
          case 'notes':
            that.tableorder = '111'
            break
          case 'daymonitortxt':
            that.tableorder = '121'
            break
        }
      }
      if(column.order == null){
        that.tableorder = ''
      }
      that.reloadTableData()
    },

    /**
     * 修改授权
     */
    editAuthorizeText: function(row, column){
      if(column.id == 'el-table_1_column_7'){
        row.isedittype = true
      }
      if(column.property == 'notes'){
        row.iseditnotes = true
      }
    },

    /**
     * 确认修改授权
     */
    saveAuthorizeText: function(auth, row){
      let that = this
      let url = that.API_URL + '/v3/price/shop/editAuth'
      let querys = {
            subid: that.subid,
            ShopName: row.ShopName,
            ChannelId: row.ChannelId,
            ShopId: row.ShopId,
            IsAuthor: auth
          }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: querys,
        success: function(data) {
          console.log('savePrice', data)
          row.isedittype = false
        },
        error: function(response) {
          console.log('savePrice', response)
        }
      })
    },

    /**
     * 卖家活跃
     */
    sellerActivilyLevel: function(l){
      let r = {
        txt: '',
        classname: ''
      }
      if (l == 1) {
        r = {
          txt: '不活跃',
          classname: ''          
        }
      } else if (l == 2) {
        r = {
          txt: '活跃',
          classname: 'status-yellow'
        }
      } else if (l == 3) {
        r = {
          txt: '高活跃',
          classname: 'status-red'          
        }
      } else {
        r = ""
      }
      return r
    },

  }  
}

</script>

<style scoped>
	.el-button--text{
		color: #CD454A;
    font-size: 12px;
	}
</style>